import React from 'react';




const TextWorks = () => {
    return (
        <section>
            <header className="bg-white py-5">
                <div className="container px-5">
                    <div className="row gx-5 align-items-center justify-content-center">
                        <div className="col-lg-8 col-xl-7 col-xxl-6">
                            <div className="my-5 text-center text-xl-start">
                                <h1 className="display-1 fw-bolder text-dark mb-2">How It Works</h1>
                                <p className="lead fw-normal text-dark-50 mb-4">
                                    Let's say I have a friend named Alex who has a solar company and is looking to sell solar panels and I also have another friend Kevin who is looking to buy solar panels. So I connect them and earn a commission.
                                </p>

                            </div>
                        </div>
                        <div className="col-xl-5 col-xxl-6 d-none d-xl-block text-center"><img className="img-fluid rounded-3 my-5" src="https://i.pinimg.com/originals/77/75/5e/77755e565ef7ddbff2546231cd8732bf.png" alt="..." /></div>
                    </div>
                </div>
            </header>

            <header className="bg-white py-5">
                <div className="container px-5">
                    <div className="row gx-5 align-items-center justify-content-center">
                        <div className="col-xl-5 col-xxl-6 d-none d-xl-block text-center"><img className="img-fluid rounded-3 my-5" src="https://image.freepik.com/vector-gratis/lider-equipo-concepto-trabajo-equipo_74855-6671.jpg" alt="..." /></div>
                        <div className="col-lg-8 col-xl-7 col-xxl-6">
                            <div className="my-5 text-center text-xl-start">
                                <h1 className="display-1 fw-bolder text-dark mb-2">Contracts </h1>
                                <p className="lead fw-normal text-dark-50 mb-4">As a company we publish our projects or products.Then users can access these publications and bring their sales proposals. If the sale concludes, users get a percentage.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </section>

    );
};

export default TextWorks;